import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

/**
 * Substitui o `TitleStrategy` padrão do Angular. Sem isso, chamar `Title.setTitle()`
 * diretamente (o que este serviço fazia antes) é sobrescrito pelo título estático da
 * rota (`title: 'Identidade Visual'` etc., em `app.routes.ts`) assim que o Router
 * processa a navegação — o `updateTitle()` padrão roda depois de qualquer chamada manual
 * a `Title.setTitle()`. Descoberto via teste E2E real: o título da aba voltava a ser o
 * da rota depois de um reload, mesmo com `ThemeApplierService.apply()` já tendo rodado.
 */
@Injectable({ providedIn: 'root' })
export class TenantTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(Title);
  private tenantTitle: string | null = null;

  /** Chamado por `ThemeApplierService.apply()` — vale para a navegação atual e todas as seguintes. */
  setTenantTitle(title: string): void {
    this.tenantTitle = title;
    this.titleService.setTitle(title);
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    if (this.tenantTitle) {
      this.titleService.setTitle(this.tenantTitle);
      return;
    }
    const title = this.buildTitle(snapshot);
    if (title !== undefined) {
      this.titleService.setTitle(title);
    }
  }
}
